import {Theme} from '@mui/material/styles';

export default function FilledInput(theme: Theme) {
  return {
    MuiFilledInput: {
      styleOverrides: {
        multiline: {
          paddingTop: '16px !important',
        },
        root: {
          backgroundColor: theme.palette.grey[100],
          border: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: '4px',
          '&.Mui-focused': {
            backgroundColor: theme.palette.grey[100],
          },
          '&:before': {
            display: 'none',
          },
          '&:hover': {
            backgroundColor: theme.palette.grey[100],
          },
        },
      },
    },
  };
}
